var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loading,
          expression: "!loading",
        },
      ],
      staticClass: "dsf-alter-password-control",
    },
    [
      !_vm.step
        ? _c(
            "div",
            { staticClass: "step-box" },
            [
              _c("p", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.title)),
                _c("span", [_vm._v(_vm._s(_vm.notice))]),
              ]),
              _c("div", { staticClass: "dsf-alter-password-label" }, [
                _vm._v("旧密码"),
              ]),
              _c("el-input", {
                staticClass: "dsf-alter-password-input",
                attrs: {
                  type: "password",
                  placeholder: "请输入旧密码",
                  "show-password": "",
                },
                model: {
                  value: _vm.oldPwd,
                  callback: function ($$v) {
                    _vm.oldPwd = $$v
                  },
                  expression: "oldPwd",
                },
              }),
              _c("br"),
              _c("div", { staticClass: "dsf-alter-password-label" }, [
                _vm._v("新密码"),
              ]),
              _c("el-input", {
                staticClass: "dsf-alter-password-input",
                attrs: {
                  type: "password",
                  placeholder: "请输入新密码",
                  "show-password": "",
                },
                model: {
                  value: _vm.newPwd,
                  callback: function ($$v) {
                    _vm.newPwd = $$v
                  },
                  expression: "newPwd",
                },
              }),
              _c("br"),
              _c("div", { staticClass: "dsf-alter-password-label" }, [
                _vm._v("确认新密码"),
              ]),
              _c("el-input", {
                staticClass: "dsf-alter-password-input",
                attrs: {
                  type: "password",
                  placeholder: "请再次输入新密码",
                  "show-password": "",
                },
                model: {
                  value: _vm.confirmPwd,
                  callback: function ($$v) {
                    _vm.confirmPwd = $$v
                  },
                  expression: "confirmPwd",
                },
              }),
              _vm.alterResult
                ? _c("p", { staticClass: "error-msg" }, [
                    _c("i", { staticClass: "iconfont icon-tixingshixin" }),
                    _vm._v(" " + _vm._s(_vm.alterResult) + " "),
                  ])
                : _vm._e(),
              _c("br"),
              _c(
                "p",
                {
                  staticStyle: {
                    color: "red",
                    "font-size": "14px",
                    height: "30px",
                    "line-height": "30px",
                    "margin-top": "15px",
                  },
                },
                [_vm._v(_vm._s(_vm.tips))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "dsf-alter-password-btn",
                  class: {
                    disabled: !(
                      _vm.oldPwd &&
                      _vm.oldPwd != _vm.newPwd &&
                      _vm.newPwd &&
                      _vm.newPwd === _vm.confirmPwd
                    ),
                  },
                  attrs: {
                    type: "primary",
                    disabled: !(
                      _vm.oldPwd &&
                      _vm.oldPwd != _vm.newPwd &&
                      _vm.newPwd &&
                      _vm.newPwd === _vm.confirmPwd
                    ),
                  },
                  on: { click: _vm.nextStep },
                },
                [_vm._v(" 下一步 ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.step
        ? _c(
            "div",
            { staticClass: "step-box" },
            [
              _vm._m(0),
              _c("p", { staticClass: "success-tip" }, [
                _vm._v(
                  "登录密码修改成功," + _vm._s(_vm.setTimeout) + "秒后自动退出"
                ),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "dsf-alter-password-success-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.backLogin },
                },
                [_vm._v(" 重新登录 ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-succss" }, [
      _c("i", { staticClass: "el-icon-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }